"use client";
import { motion } from "framer-motion";
import { Home, ThumbsUp } from "lucide-react";

export function AboutSection() {
  return (
    <section className="container mx-auto px-4 py-16 md:py-24 overflow-hidden">
      <div className="text-center mb-12 md:mb-16">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-blue-600 font-medium block mb-4"
        >
          About Our Services
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-4xl md:text-5xl font-bold leading-none"
        >
          Delivering Logistics Excellence, Every Step
        </motion.h2>
      </div>
      <div className="flex gap-8 items-center flex-col lg:flex-row">
        {/* Images Column */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full flex lg:w-3/6 gap-4"
        >
          <div className="relative h-[400px] md:h-[500px] w-[55%]">
            <img
              src="/images/burg_khlifa.jpg"
              alt="Medical Professional"
              className="object-cover rounded-lg w-full h-full"
            />
          </div>
          <div className="relative h-[400px] md:h-[500px] mt-8 w-[45%]">
            <img
              src="/images/health-care1.png"
              alt="Medical Consultation"
              className="object-cover rounded-lg w-full h-full"
            />
          </div>
        </motion.div>


        {/* Content Column */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="w-full lg:w-3/6 text-left xl:pr-12"
        >

          <h2 className="text-4xl md:text-5xl font-bold leading-tight">
            Comprehensive Chemical Solutions for Diverse Industries

          </h2>

          <div className="flex flex-wrap gap-4 my-3">
            <div className="flex items-center gap-2 bg-white rounded-lg shadow-lg px-4 py-3">
              <Home className="h-5 w-5 text-primary" />
              <span className="font-medium">Free Consultation</span>
            </div>
          </div>

          <p className="text-muted-foreground my-4">
            At Interpetro Chemicals Trading FZ-LLC, we provide cutting-edge chemical solutions tailored to meet the diverse needs of manufacturers across industries. With a strong presence in Africa, the Middle East, the Subcontinent, and Southeast Asia, our services ensure quality, efficiency, and innovation.
          </p>


        </motion.div>
      </div>
    </section>
  );
}
